import styled from 'styled-components'
import { rem } from 'polished'
import media from '../../../utils/style'

const CTAGroup = styled.div`
  text-align: center;
  margin-bottom: 24px;

  a {
    color: ${(props) => props.theme.colors.white};
    display: block;
    padding: 5px;
    width: 100%;
    text-decoration: none;
    font-weight: ${(props) => props.theme.weights[1]};
    font-size: ${(props) => rem(props.theme.fontSizes[3])};
    &:hover {
      color: ${(props) => props.theme.colors.white};
    }
    &[disabled] {
      pointer-events: none;
    }

    ${media.LargeScreenUp`
    padding: 6px 8px 8px;
    `};
  }

  & > div {
    color: ${(props) => props.theme.colors.white};
    border-radius: 4px;
    margin-bottom: 16px;
    background-color: ${(props) => props.theme.colors.green};

    &:nth-child(2),
    &:nth-child(3) {
      background-color: ${(props) => props.theme.colors.white};
      color: ${(props) => props.theme.colors.black};
      border: 2px solid
        ${(props) =>
          props.disabled
            ? props.theme.colors.grey_light_op65
            : props.theme.colors.blue};

      a {
        color: ${(props) =>
          props.disabled
            ? props.theme.colors.grey_light
            : props.theme.colors.blue};
      }
    }

    &.youtube {
      background-color: ${(props) => props.theme.colors.white};
      border: 2px solid ${(props) => props.theme.colors.grey_light};
      svg {
        height: 20px;
      }
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        color: ${(props) => props.theme.colors.black};
      }
    }
  }
`

CTAGroup.displayName = 'CTAGroup'

export { CTAGroup }
